// AI画像解析用カテゴリー
const AIImageCategory = {
  namespaced: true,

  state: {
    formItem: {
      f_exterior: 1, // 建物外観
      f_entrance: 1, // エントランス
      f_lobby: 1, // ロビー
      f_parking: 1, // 駐車場
      f_other_common: 1, // その他共有部分
      f_living: 1, // 居室・リビング
      f_other_space: 1, // その他部屋・スペース
      f_kitchen: 1, // キッチン
      f_bathroom: 1, // バス
      f_toilet: 1, // トイレ
      f_powder_room: 1, // 洗面所
      f_storage: 1, // 収納
      f_balcony: 1, // バルコニー
      f_garden: 1, // 庭
      f_room_door: 1, // 玄関
      f_security: 1, // セキュリティ
      f_other_facility: 1, // その他設備
      f_view: 1, // 眺望
      f_other: 1, // その他
      f_atbb_interior: 1, // 室内(ATBB専用)
      f_floor_plan: 1, // 間取
      f_wasitu: 1, // 和室
      f_yousitu: 1, // 洋室
      f_kids_room: 1, // 子供部屋
      f_bed_room: 1, // 寝室
      f_interior: 1, // 内観
      f_flyer: 1, // チラシ
    },
  },
  getters: {
    getFormItem: state => {
      return state.formItem
    },
  },
  mutations: {
    setFormItem(state, list) {
      state.formItem = list
    },
    resetFormItem(state) {
      state.formItem = {
        f_exterior: 1, // 建物外観
        f_entrance: 1, // エントランス
        f_lobby: 1, // ロビー
        f_parking: 1, // 駐車場
        f_other_common: 1, // その他共有部分
        f_living: 1, // 居室・リビング
        f_other_space: 1, // その他部屋・スペース
        f_kitchen: 1, // キッチン
        f_bathroom: 1, // バス
        f_toilet: 1, // トイレ
        f_powder_room: 1, // 洗面所
        f_storage: 1, // 収納
        f_balcony: 1, // バルコニー
        f_garden: 1, // 庭
        f_room_door: 1, // 玄関
        f_security: 1, // セキュリティ
        f_other_facility: 1, // その他設備
        f_view: 1, // 眺望
        f_other: 1, // その他
        f_atbb_interior: 1, // 室内(ATBB専用)
        f_floor_plan: 1, // 間取
        f_wasitu: 1, // 和室
        f_yousitu: 1, // 洋室
        f_kids_room: 1, // 子供部屋
        f_bed_room: 1, // 寝室
        f_interior: 1, // 内観
        f_flyer: 1, // チラシ
      }
    },
  },
}

export default AIImageCategory
